import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './AddPurchase.css';
import axios from "axios";

const EditAidedStaffSalary = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { salary_id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    salary_id: "",
    name: "",
    basic: "",
    sp: "",
    wa: "",
    da_per: "",
    da_amt: "",
    hra: "",
    ma: "",
    gross: "",
    tpf: "",
    tpfd: "",
    cps_r: "",
    cps_a1: "",
    gis: "",
    nhis: "",
    fa_coop: "",
    pt: "",
    it_sr: "",
    deduction: "",
    net_salary: "",
  });

  const [errors, setErrors] = useState({});

  // useEffect(() => {
  //   // TODO: Fetch existing data by ID from backend
  //   console.log("Editing Aided Staff Salary ID:", salary_id);

  //   // Example placeholder:
  //   const existingData = {
  //     staffName: "Maha",
  //     basic: "25000",
  //     sp: "2000",
  //     wa: "1500",
  //     da: "5000",
  //     hra: "3200",
  //     ma: "300",
  //     gross: "37000",
  //     tpf: "1000",
  //     tpfd: "500",
  //     cpsr: "800",
  //     cpsa1: "600",
  //     gis: "110",
  //     nhis: "300",
  //     facoop: "200",
  //     ptitsr: "150",
  //     deduction: "3660",
  //     netSalary: "33340",
  //   };

  //   setFormData(existingData);
  // }, [salary_id]);
  useEffect(() => {
      axios.post(`${API_BASE_URL}salary_aided_detail.php`,{salary_id:salary_id})
        .then((response) => {
          if (response.data.head.code === 200 ) {
            setFormData(response.data.body);
            // setFilteredOrders(response.data.body);
            // console.log(response.data.body[0]);
  
          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
            setFormData([]);
            // setFilteredOrders([]);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
          setFormData([]);
          // setFilteredOrders([]);
        }).finally(() => {
          // setLoading(false); // Set loading to false after API call
        });
    }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      let updated = { ...prev, [name]: value };

      // DA % → DA Amount
      if (name === "da_per") {
        const percent = Number(value) || 0;
        const basic = Number(prev.basic) || 0;
        updated.da_amt = ((basic * percent) / 100).toFixed(2);
      }

      return updated;
    });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Staff name is required";
    if (!formData.basic) newErrors.basic = "Basic salary is required";
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      console.log("Updated:", formData);
      // TODO: Submit updated data to backend
      axios.post(`${API_BASE_URL}salary_aided_detail_edit.php`, formData)
        .then((response) => {
          if (response.data.head.code === 200) {
            // setDepartmentList(response.data.body);
            // setFilteredOrders(response.data.body);
            window.history.back();
            // navigate("/salaryaided");
            // navigate("/salarysf");

          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
            // setDepartmentList([]);
            // setFilteredOrders([]);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
          // setDepartmentList([]);
          // setFilteredOrders([]);
        }).finally(() => {
          // setLoading(false); // Set loading to false after API call
        });
      
    }
  };

  const renderError = (field) =>
    errors[field] && <small className="text-danger">{errors[field]}</small>;

  useEffect(() => {
      const gross =
        (Number(formData.basic) || 0) +
        (Number(formData.sp) || 0) +
        (Number(formData.wa) || 0) +
        (Number(formData.da_amt) || 0) +
        (Number(formData.hra) || 0) +
        (Number(formData.ma) || 0);
  
      const deduction =
        (Number(formData.tpf) || 0) +
        (Number(formData.tpfd) || 0) +
        (Number(formData.cps_r) || 0) +
        (Number(formData.cps_a1) || 0) +
        (Number(formData.gis) || 0) +
        (Number(formData.nhis) || 0) +
        (Number(formData.fa_coop) || 0) +
        (Number(formData.pt) || 0) +
        (Number(formData.it_sr) || 0);
  
        const netSalaryAmount =gross -deduction;
  
      setFormData((prev) => ({
        ...prev,
        gross: gross.toFixed(2),
        deduction: deduction.toFixed(2),
        net_salary: netSalaryAmount.toFixed(2),
      }));
    }, [
      formData.basic,
      formData.sp,
      formData.wa,
      formData.da_amt,
      formData.hra,
      formData.ma,
      formData.tpf,
      formData.tpfd,
      formData.cps_r,
      formData.cps_a1,
      formData.gis,
      formData.nhis,
      formData.fa_coop,
      formData.pt,
      formData.it_sr,
    ]);

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Edit Aided Staff Salary</h4>
        <button className="btn-top" onClick={() => navigate(-1)}>Back</button>
      </div>

      <form onSubmit={handleSubmit} noValidate>
        <div className="row g-3">
          {[
            { label: "Staff Name", name: "name" },
            { label: "Basic", name: "basic" },
            { label: "SP", name: "sp" },
            { label: "WA", name: "wa" },
            { label: "DA %", name: "da_per" },
            { label: "DA", name: "da_amt" },
            { label: "HRA", name: "hra" },
            { label: "MA", name: "ma" },
            { label: "Gross", name: "gross" },
            { label: "TPF", name: "tpf" },
            { label: "TPFD", name: "tpfd" },
            { label: "CPS(R)", name: "cps_r" },
            { label: "CPS(A1)", name: "cps_a1" },
            { label: "GIS", name: "gis" },
            { label: "NHIS", name: "nhis" },
            { label: "FA/Coop", name: "fa_coop" },
            { label: "PT", name: "pt" },
            { label: "IT/SR", name: "it_sr" },
            { label: "Deduction", name: "deduction" },
            { label: "Net Salary", name: "net_salary" },
          ].map(({ label, name }) => (
            <div className="col-lg-4 col-md-6 col-sm-12" key={name}>
              <label className="form-label">{label}</label>
              <input
                type="text"
                className="form-control"
                name={name}
                value={formData[name]}
                onChange={handleChange}
              />
              {renderError(name)}
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-end mt-4 gap-2">
          <button type="submit" className="btn-submit">Update</button>
          <button type="button" className="btn-cancel" onClick={() => navigate(-1)}>Cancel</button>
        </div>
      </form>
    </div>
  );
};

export default EditAidedStaffSalary;
